<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import DwdcblrBrowse from "./DwdcblrBrowse";
import DwdcblrEdit from "./DwdcblrEdit";
import DwdcblrForm from "./DwdcblrForm";
import YyxmAdd from "../components/YyxmAdd";
import QqxmAdd from "../components/QqxmAdd";
import KhfyAdd from "../components/KhfyAdd";
import ZxgcsAdd from "../components/ZxgcsAdd";
import ZcjgAdd from "../components/ZcjgAdd";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters, mapActions } = createNamespacedHelpers("user");
export default {
    name: "Dwdcblr",
    components: { DwdcblrBrowse, DwdcblrEdit, DwdcblrForm, YyxmAdd, QqxmAdd, KhfyAdd, ZxgcsAdd, ZcjgAdd },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    created() {
        if (this.getNoticeId) {
            this.setNoticeId(null);
            this.editProps.showEdit = true;
        }
    },
    computed: {
        ...userMapGetters(["getNoticeId"]),
        compName() {
            if (this.editProps.showEdit === true) {
                return "DwdcblrEdit";
            } else if (this.editProps.showForm === true) {
                return "DwdcblrForm";
            } else {
                return "DwdcblrBrowse";
            }
        }
    },
    methods: {
        ...mapActions(["setNoticeId"])
    }
};
</script>
